require('es6-promise/auto');

function getTitle(player) {
  const parentContainer = player.parentElement.parentElement;
  parentContainer.hidden = false;

  const heading = parentContainer.querySelector('[data-js-bind="video-title"]');
  if (!heading) return;

  const vimeo = new Vimeo.Player(player);
  vimeo.getVideoTitle().then(function(title) {
    heading.innerText = title;
  }).catch(function() {});
}

function initVimeo() {
  const players = document.querySelectorAll('[data-module="vimeo"] [data-js-bind="video"]');

  for (let i = 0; i < players.length; i++) {
    getTitle(players[i])
  }
}

function loadVimeoAPI() {
  const scriptElement = document.createElement('script');
  scriptElement.addEventListener('load', initVimeo);
  scriptElement.async = true;
  scriptElement.src = 'https://player.vimeo.com/api/player.js';
  document.body.appendChild(scriptElement);
}

function checkForVimeoContainer() {
  const vimeoContainer = document.querySelector('[data-module="vimeo"]');
  if(!vimeoContainer) return;
  loadVimeoAPI();
}

checkForVimeoContainer();
